import { Outlet, useLocation } from 'react-router-dom';

// material-ui
import { Box } from '@mui/material';

// project imports
import Footer from '../Footer';
import Customization from '../Customization';

// ==============================|| MINIMAL LAYOUT ||============================== //

const MinimalLayout = () => {
    const location = useLocation();
    
    // Não mostrar footer nas páginas de autenticação e páginas de política/termos
    const isAuthPage = location.pathname === '/login' || location.pathname === '/forgot';
    const isPolicyPage = location.pathname === '/politica-de-privacidade' || 
                        location.pathname === '/termos-de-uso' || 
                        location.pathname === '/politica-de-privacidade/exclusao-facebook';
    const shouldHideFooter = isAuthPage || isPolicyPage;
    
    return (
        <Box sx={{ 
            display: 'flex', 
            flexDirection: 'column', 
            minHeight: '100vh',
            overflow: shouldHideFooter ? 'hidden' : 'auto',
            ...(shouldHideFooter && {
                '& .MuiBox-root': {
                    marginTop: 0
                }
            })
        }}>
            <Box sx={{ 
                flex: 1, 
                pb: shouldHideFooter ? 0 : 10, 
                pt: shouldHideFooter ? 0 : 2, 
                minHeight: shouldHideFooter ? '100vh' : 'calc(100vh - 60px)',
                overflow: shouldHideFooter ? 'hidden' : 'auto',
                marginTop: shouldHideFooter ? 0 : 'auto'
            }}>
                <Outlet />
            </Box>
            {!shouldHideFooter && <Footer />}
            {/* <Customization /> */}
        </Box>
    );
};

export default MinimalLayout;
